import script from "./FilmDescription.vue?vue&type=script&setup=true&lang=js"
export * from "./FilmDescription.vue?vue&type=script&setup=true&lang=js"

import "./FilmDescription.vue?vue&type=style&index=0&id=9e1d2ed0&lang=scss&scoped=true"

import exportComponent from "/Volumes/Quoicoubeh/Paraleclypse/website/paraleclypse/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e1d2ed0"]])

export default __exports__